import { generalKey } from '../../config/pageConfig';
import ProductNav from '../../common/ProductNav';
import NA_Product from './NA_Product';
import JP_Product from './JP_Product';
import EU_Product from './EU_Product';
import AU_Product from './AU_Product';
import getLocal from '@/app/utils/getLocal';
import './index.scss';
import EfScrollAni from '@/efscrollani';
import { useGlobal } from '@/utils/useGlobal';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';

export default function ExampleProductA() {
    const { gloproductlist } = useGlobal();
    const { locale = 'us' } = getLocal();

    const IS_NA_SITE = ['us', 'ca'].includes(locale);
    const IS_JP_SITE = locale === 'jp';
    const IS_EU_SITE = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale);
    const IS_AU_SITE = locale === 'au';

    const { buyLink } = getProductFromGeneralKey({ gloproductlist, generalKey });

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className="page-product">
            <ProductNav activeTab={'Product'} buyLink={buyLink} />
            {IS_JP_SITE && <JP_Product />}
            {IS_NA_SITE && <NA_Product />}
            {IS_EU_SITE && <EU_Product />}
            {IS_AU_SITE && <AU_Product />}
        </div>
    );
}
